import { render, staticRenderFns } from "./second.vue?vue&type=template&id=c2dd8418&scoped=true&"
import script from "./second.vue?vue&type=script&setup=true&lang=js&"
export * from "./second.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd8418",
  null
  
)

export default component.exports